<template>
  <v-container class="residential-complexes-page" fluid>
    <div class="residential-complexes-header">
      <h1 class="residential-complexes-header__title">{{ $route.meta.title }}</h1>
      <div class="residential-complexes-header__actions">
        <v-btn
          v-if="isBtnListResCom"
          color="primary"
          class="residential-complexes-header__btn text-none"
          dark
          rounded
          @click="addResidentComplex"
        >
          <v-icon left>mdi-plus</v-icon>
          Новый жилой комплекс
        </v-btn>
      </div>
    </div>

    <v-card class="residential-complexes-block mt-3" flat outlined>
      <div class="residential-complexes-filters">
        <div class="residential-complexes-filters__title">
          <v-icon left small>mdi-filter-variant</v-icon>
          Фильтры
        </div>
        <div class="residential-complexes-filters__row">
          <v-text-field
            v-model="searchValueResidentialComplexes"
            placeholder="Поиск по названию"
            prepend-inner-icon="mdi-rename-box-outline"
            outlined
            dense
            hide-details
            class="residential-complexes-filters__field"
          />
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table row-click"
        :headers="headersResidentialComplexes"
        :items="filteredResidentialComplexes"
        @click:row="rowDetail"
      >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ResidentialComplexes',
  data () {
    return {
      listResidentialComplexes: false,
      resResidentialComplexes: [],
      cachedResidentialComplexes: null,
      searchValueResidentialComplexes: '',
      isBtnListResCom: false,
      headersResidentialComplexes: [
        { text: 'id', value: 'id' },
        { text: 'Название', value: 'name', sortable: false },
        { text: 'Комментарий', value: 'comment', sortable: false },
      ],
    };
  },
  async created () {
    if (this.cachedResidentialComplexes) {
      this.resResidentialComplexes = this.cachedResidentialComplexes;
      this.listResidentialComplexes = true;
      return;
    }
    try {
      const data = await this.getResidentialComplex();
      this.cachedResidentialComplexes = data.data;
      this.resResidentialComplexes = data.data;
      this.listResidentialComplexes = true;
    } catch (e) {
      console.error(e);
      this.$flash_warning('Ошибка в получении списка ЖК');
    }
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.isBtnListResCom = true;
        break;
    }
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filteredResidentialComplexes () {
      let complexPolygons = this.resResidentialComplexes;

      if (this.searchValueResidentialComplexes) {
        complexPolygons = complexPolygons.filter(doorphone => {
          return doorphone.name.toString().toLowerCase().includes(this.searchValueResidentialComplexes.toLowerCase());
        });
      }

      return complexPolygons;
    },
  },
  methods: {
    ...mapActions({
      getResidentialComplex: 'ResidentComplex/getComplex',
    }),
    addResidentComplex () {
      this.$router.push({ name: 'TheMap', query: { showModal: 'true' } });
    },
    rowDetail (value) {
      let { id } = value;
      if (!id) {
        id = value;
      }
      this.$router.push({ name: 'BaseResComplex', params: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.residential-complexes-page {
  padding: 24px;
}

.residential-complexes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.residential-complexes-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.residential-complexes-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.residential-complexes-header__btn {
  text-transform: none;
  font-weight: 500;
}

.residential-complexes-block {
  border-radius: 12px;
  overflow: hidden;
}

.residential-complexes-filters {
  padding: 10px 16px 8px;
}

.residential-complexes-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.residential-complexes-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.residential-complexes-filters__field {
  max-width: 320px;
  width: 100%;
  min-width: 180px;
}

.v-btn {
  text-transform: none;
}

.row-click {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .residential-complexes-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .residential-complexes-header__title {
    font-size: 1.4rem;
  }

  .residential-complexes-filters__field {
    max-width: none;
  }
}
</style>
